module.exports = __webpack_public_path__ + "static/media/backgroundImg2.f951fce6.jpg";